module.exports = __webpack_public_path__ + "static/media/img_skill_validation_03.d7065771.png";